import {
  ComparisonMetricProfile,
  comparisonCompaniesCountProfile,
  comparisonCompaniesRevenueProfile,
  comparisonEconomicParticipantProfile,
  comparisonGvaProfile,
} from '../comparison-metric.profile';
import { DashboardComparisonStructureViewInput } from './create-dashboard-comparison-structure-definition';

/** Resolved time filter; `manualYear` carries its year window. */
/**
 * Structure-shell metric profile: shared comparison pipeline core +
 * structure presentation / filter defaults (first-class, not catalog extras).
 * Type-filter exclusions come from shared `filter.optionsByGranularity`
 * via `createMetricFilters(shell.granularityId)`.
 */
export type ComparisonStructureMetricProfile = ComparisonMetricProfile & DashboardComparisonStructureViewInput;

function fromShared(
  shared: ComparisonMetricProfile,
  structure: DashboardComparisonStructureViewInput,
): ComparisonStructureMetricProfile {
  return {
    ...shared,
    ...structure,
  };
}

export const comparisonStructureCompaniesCountProfile: ComparisonStructureMetricProfile =
  fromShared(comparisonCompaniesCountProfile, {
    structureLabel: 'UNTERNEHMENSTRUKTUR',
    valueKey: 'companies_count',
    chartMetricTitle: 'Anzahl Unternehmen',
    popupValueLabel: 'Verteilung der Unternehmen',
  });

export const comparisonStructureCompaniesRevenueProfile: ComparisonStructureMetricProfile =
  fromShared(comparisonCompaniesRevenueProfile, {
    structureLabel: 'UMSATZSTRUKTUR',
    valueKey: 'companies_revenue__k_eur',
    chartMetricTitle: 'Umsatz in Tsd. EUR',
    popupValueLabel: 'Umsatzverteilung in Tsd. EUR',
  });

export const comparisonStructureGrossValueAddedProfile: ComparisonStructureMetricProfile =
  fromShared(comparisonGvaProfile, {
    structureLabel: 'BRUTTOWERTSCHÖPFUNGSSTRUKTUR',
    valueKey: 'gross_value_added__k_eur',
    chartMetricTitle: 'Bruttowertschöpfung in Tsd. EUR',
    popupValueLabel: 'Verteilung der Bruttowertschöpfung in Tsd. EUR',
  });

export const comparisonStructureEconomicParticipantProfile: ComparisonStructureMetricProfile =
  fromShared(comparisonEconomicParticipantProfile, {
    structureLabel: 'KERNERWERBSTÄTIGENSTRUKTUR',
    valueKey: 'economic_participants_core_market',
    chartMetricTitle: 'Anzahl der Kernerwerbstätigen',
    popupValueLabel: 'Verteilung der Kernerwerbstätigen',
  });
